import {
  getMockChatConversations,
  getMockChatMessages,
  getMockConversationMembers,
  getMockGroupConversationById,
  getMockOnlineProfiles,
  getMockPrivateConversationById,
  getMockUnreadMessagesCount,
} from "../demo/mockChat";

const noop = async (..._args: any[]) => ({ Success: true });

const createNewConversation = async (
  _academyId?: string,
  _profileId?: string,
  _profileType?: number
): Promise<string> => "00000000-0000-0000-0000-00000000c999";

const createNewGroupConversation = async (
  _academyId?: string,
  _name?: string,
  _logo?: string,
  _members?: Array<{ InterlocutorId: string; ProfileType: number }>,
  _id?: string,
  _isForAdultOnly?: boolean
): Promise<string> => "00000000-0000-0000-0000-00000000c998";

export type ChatService = {
  getAllConversations: typeof getMockChatConversations;
  getAllConversationsWithAcademyId: typeof getMockChatConversations;
  getConversation: typeof getMockChatMessages;
  getGroupConversationById: typeof getMockGroupConversationById;
  getPrivateConversationById: typeof getMockPrivateConversationById;
  getConversationMembers: typeof getMockConversationMembers;
  getAllUnreadMessages: typeof getMockUnreadMessagesCount;
  getOnlineProfiles: typeof getMockOnlineProfiles;
  createNewConversation: typeof createNewConversation;
  createNewGroupConversation: typeof createNewGroupConversation;
  sendMessage: typeof noop;
  sendVoiceMessage: typeof noop;
  sendFile: typeof noop;
  replyToMessage: typeof noop;
  readMessage: typeof noop;
  readMessageById: typeof noop;
  removeMessage: typeof noop;
  removeConversation: typeof noop;
  removeGroupConversation: typeof noop;
  leaveConversation: typeof noop;
  deleteProfileFromConversation: typeof noop;
  joinProfileToConversation: typeof noop;
  changeConversationName: typeof noop;
  changeConversationLogo: typeof noop;
};

const chatService: ChatService = {
  getAllConversations: getMockChatConversations,
  getAllConversationsWithAcademyId: getMockChatConversations,
  getConversation: getMockChatMessages,
  getGroupConversationById: getMockGroupConversationById,
  getPrivateConversationById: getMockPrivateConversationById,
  getConversationMembers: getMockConversationMembers,
  getAllUnreadMessages: getMockUnreadMessagesCount,
  getOnlineProfiles: getMockOnlineProfiles,
  createNewConversation,
  createNewGroupConversation,
  sendMessage: noop,
  sendVoiceMessage: noop,
  sendFile: noop,
  replyToMessage: noop,
  readMessage: noop,
  readMessageById: noop,
  removeMessage: noop,
  removeConversation: noop,
  removeGroupConversation: noop,
  leaveConversation: noop,
  deleteProfileFromConversation: noop,
  joinProfileToConversation: noop,
  changeConversationName: noop,
  changeConversationLogo: noop,
};

export const getAllConversations = chatService.getAllConversations;
export const getAllConversationsWithAcademyId = chatService.getAllConversationsWithAcademyId;
export const getConversation = chatService.getConversation;
export const getGroupConversationById = chatService.getGroupConversationById;
export const getPrivateConversationById = chatService.getPrivateConversationById;
export const getConversationMembers = chatService.getConversationMembers;
export const getAllUnreadMessages = chatService.getAllUnreadMessages;
export const getOnlineProfiles = chatService.getOnlineProfiles;
export { createNewConversation, createNewGroupConversation };

export default chatService;
